/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from "react";

import { IToysrusGiftfinderArData } from "./toysrus-giftfinder-ar.data";
import { IToysrusGiftfinderArProps } from "./toysrus-giftfinder-ar.props.autogenerated";

export interface IToysrusGiftfinderArViewProps
    extends IToysrusGiftfinderArProps<IToysrusGiftfinderArData> {
        budgetAmount: number;
        budgetAmountMin: number;
        budgetAmountMax: number;
        onBudgetAmountInput: (val: any) => void;
        onBudgetAmountMinInput: (val: any) => void;
        onBudgetAmountMaxInput: (val: any) => void;
        isAgeSelected: boolean;
        isGenderSelected: boolean;
        giftfinderBack: () => void;
        giftfinderBack1: () => void;
        giftfinderNext: () => void;
        giftfinderNext1: () => void;
        getGiftSuggestions: () => void;
        onAgeInput: () => void;
        onGenderInput: () => void;
        ageGroups: IAgeGroup[];
        genderGroups: IGenderGroup[];
}

export interface IToysrusGiftfinderArState {
    budgetAmount: number;
    budgetAmountMin: number,
    budgetAmountMax: number,
    isAgeSelected: boolean;
    isGenderSelected: boolean;
    selectedAgeGroups: string[];
    selectedGenderGroups: string[];
}

export interface IAgeGroup {
    ageLabel: string;
    ageValue: string;
    id: string;
    isChecked: boolean;
    containerClassName: string;
}

export interface IGenderGroup {
    genderLabel: string;
    genderValue: string;
    id: string;
    isChecked: boolean;
    containerClassName: string;
}


/**
 *
 * ToysrusGiftfinderAr component
 * @extends {React.PureComponent<IToysrusGiftfinderArProps<IToysrusGiftfinderArData>>}
 */
class ToysrusGiftfinderAr extends React.PureComponent<
    IToysrusGiftfinderArProps<IToysrusGiftfinderArData>,
    IToysrusGiftfinderArState
> {
    public constructor(props: IToysrusGiftfinderArViewProps) {
        super(props);

        this.state = {
            budgetAmount: 1,
            budgetAmountMin: 101,
            budgetAmountMax: 2001,
            isAgeSelected: false,
            isGenderSelected: false,
            selectedAgeGroups: [],
            selectedGenderGroups: ["بنات"],
        };
    }

    public render(): JSX.Element | null {
        var ageGroups: IAgeGroup[]  = [
            {
                ageLabel: "0-18 شهور",
                ageValue: "0-18 شهور",
                id: "c1",
                isChecked: this.state.selectedAgeGroups.findIndex(sag => sag === "0-18 شهور") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer1",
            },
            {
                ageLabel: "24-36 شهور",
                ageValue: "24-36 شهور",
                id: "c2",
                isChecked: this.state.selectedAgeGroups.findIndex(sag => sag === "24-36 شهور") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer2",
            },
            {
                ageLabel: "3-5 سنوات",
                ageValue: "3-5 سنوات",
                id: "c3",
                isChecked: this.state.selectedAgeGroups.findIndex(sag => sag === "3-5 سنوات") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer3",
            },
            {
                ageLabel: "6-8 سنوات",
                ageValue: "6-8 سنوات",
                id: "c4",
                isChecked: this.state.selectedAgeGroups.findIndex(sag => sag === "6-8 سنوات") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer4",
            },
            {
                ageLabel: "9-11 سنوات",
                ageValue: "9-11 سنوات",
                id: "c5",
                isChecked: this.state.selectedAgeGroups.findIndex(sag => sag === "9-11 سنوات") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer5",
            },
            {
                ageLabel: "12+ سنوات",
                ageValue: "12+ سنوات",
                id: "c6",
                isChecked: this.state.selectedAgeGroups.findIndex(sag => sag === "12+ سنوات") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer6",
            }
        ]



        var genderGroups: IGenderGroup[]  = [
            {
                genderLabel: "اولاد",
                genderValue: "اولاد",
                id: "c2",
                isChecked: this.state.selectedGenderGroups.findIndex(sag => sag === "اولاد") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer2",
            },
            {
                genderLabel: "بنات",
                genderValue: "بنات",
                id: "c1",
                isChecked: this.state.selectedGenderGroups.findIndex(sag => sag === "بنات") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer1",
            }
        ]



        return this.props.renderView({
            ...this.props,
            budgetAmount: this.state.budgetAmount,
            budgetAmountMax: this.state.budgetAmountMax,
            budgetAmountMin: this.state.budgetAmountMin,
            onBudgetAmountInput: this.onBudgetAmountInput,
            onBudgetAmountMaxInput: this.onBudgetAmountMaxInput,
            onBudgetAmountMinInput: this.onBudgetAmountMinInput,
            isAgeSelected: this.state.isAgeSelected,
            isGenderSelected: this.state.isGenderSelected,
            giftfinderBack: this.giftfinderBack,
            giftfinderBack1: this.giftfinderBack1,
            giftfinderNext: this.giftfinderNext,
            giftfinderNext1: this.giftfinderNext1,
            getGiftSuggestions: this.getGiftSuggestions,
            ageGroups: ageGroups,
            genderGroups: genderGroups,
            onAgeInput: this.updateSelectedAgeGroups,
            onGenderInput: this.updateSelectedGenderGroups
        });
    }

    public onBudgetAmountInput = (val: any) => {
        this.setState({ budgetAmount: val.currentTarget.value });
    };

    public onBudgetAmountMinInput = (val: number) => {
        this.setState({ budgetAmountMin: val });
    };

    public onBudgetAmountMaxInput = (val: number) => {
        this.setState({ budgetAmountMax: val });
    };

    public giftfinderBack = () => {
        this.setState({ isAgeSelected: false });
    };

    public giftfinderBack1 = () => {
        this.setState({ isGenderSelected: false });
    };

    public giftfinderNext = () => {
        this.updateSelectedAgeGroups();
        this.setState({ isAgeSelected: true });
    };

    public giftfinderNext1 = () => {
        this.updateSelectedGenderGroups();
        this.setState({ isGenderSelected: true });
    };

    public updateSelectedAgeGroups = () => {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[name="color"]:checked'
        );
        let selectedAgeGroups: string[] = [];
        checkboxes.forEach((checkBoxElement: HTMLInputElement) => {
            selectedAgeGroups.push(checkBoxElement.value);
        });

        this.setState({ selectedAgeGroups: selectedAgeGroups });
    };

    public updateSelectedGenderGroups = () => {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[name="gender"]:checked'
        );
        let selectedGenderGroups: string[] = [];
        checkboxes.forEach((checkBoxElement: HTMLInputElement) => {
            selectedGenderGroups.push(checkBoxElement.value);
        }); 

        this.setState({ selectedGenderGroups: selectedGenderGroups });
    };

    public getGiftSuggestions = () => {

        var genderGroupFilters: string[] = [];
        
        this.state.selectedGenderGroups.forEach((genderGroupValue: string) => {
            let genderGroupFilter = '[5,"'+genderGroupValue+'",5637146827,1,"'+genderGroupValue+'",""]';
             genderGroupFilters.push(genderGroupFilter);
         });


         if (!genderGroupFilters || genderGroupFilters.length == 0) {
            var genderfinalfilter = '[5,"بنات",5637146827,1,"بنات",""]';
         } else {
            var genderfinalfilter = genderGroupFilters[0];
         }
   
         console.log(genderfinalfilter);

        var maxPrice = this.state.budgetAmountMax;
        var minPrice = this.state.budgetAmountMin;
        var pricerange = `[1,"${minPrice}",0,3,"${maxPrice}","SAR"]`;

        var ageGroupFilters: string[] = [];
        var agegpstrt = "[";
        var agegpend = "]";

        this.state.selectedAgeGroups.forEach((ageGroupValue: string) => {
            let ageGroupFilter = '[5,"' + ageGroupValue + '",5637146826,1,"' + ageGroupValue + '",""]';
            ageGroupFilters.push(ageGroupFilter);
        });

        if (!ageGroupFilters || ageGroupFilters.length == 0) {
            var agefinalfilter = agegpstrt + pricerange + "," + genderfinalfilter + agegpend;
        } else {
            var agefinalfilter = agegpstrt + pricerange + "," + ageGroupFilters + "," + genderfinalfilter + agegpend;
        }

        // [[1,"2",0,3,"2859","SAR"],[5,"0-18 Months",5637146826,1,"0-18 Months",""],[5,"GIRLS",5637146827,1,"GIRLS",""]]

       // console.log(agefinalfilter); 
        agefinalfilter = encodeURIComponent(agefinalfilter);
        console.log(agefinalfilter);
        
        window.location.assign(
            "https://www.toysrus.com.sa/ar-sa/5637226331.c?refiners=" + agefinalfilter
        );

        // var maxprice = this.state.budgetAmount;
        // var pricerange = '[1,"1",0,3,"' + maxprice + '","SAR"]';

        // var ageGroupFilters: string[] = [];
        // var agegpstrt = "[";
        // var agegpend = "]";

        // this.state.selectedAgeGroups.forEach((ageGroupValue: string) => {
        //     let ageGroupFilter = '[5,"' + ageGroupValue + '",5637146826,1,"' + ageGroupValue + '",""]';
        //     ageGroupFilters.push(ageGroupFilter);
        // });

        // if (!ageGroupFilters || ageGroupFilters.length == 0) {
        //     var agefinalfilter = agegpstrt + pricerange + agegpend;
        // } else {
        //     var agefinalfilter = agegpstrt + pricerange + "," + ageGroupFilters + agegpend;
        // }

        // agefinalfilter = encodeURIComponent(agefinalfilter);

        // window.location.assign(
        //     "https://www.toysrus.com.sa/ar-sa/5637226331.c?refiners=" + agefinalfilter
        // );       
    };
}

export default ToysrusGiftfinderAr;
